import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "3808c7cb-cc74-41bf-896d-5464d6bb478c",
    content: "Answer 1",
    options: {
      image: `${config.ASSETS_URL}/04/09/task/task-1-answer-1.svg`,
    },
  },
  {
    id: "50528261-3cf8-4647-95ad-ab5c8c28204f",
    content: "Answer 2",
    options: {
      image: `${config.ASSETS_URL}/04/09/task/task-1-answer-2.svg`,
    },
  },
  {
    id: "c821be20-f5f3-4317-b3e7-60e70496269d",
    content: "Answer 3",
    options: {
      image: `${config.ASSETS_URL}/04/09/task/task-1-answer-3.svg`,
    },
  },
  {
    id: "3f6efcab-1fff-452f-9a50-628571d31781",
    content: "Answer 4",
    options: {
      image: `${config.ASSETS_URL}/04/09/task/task-1-answer-4.svg`,
    },
  },
];

export const task: Task = {
  id: "a58a308f-7560-4b9e-b0e6-33182d399979",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c821be20-f5f3-4317-b3e7-60e70496269d"],
};
